import React from "react";

export default function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative pt-32 pb-12 overflow-hidden section-radial border-b border-white/5">
      <div className="absolute top-0 right-1/4 h-56 w-56 rounded-full bg-brand-emerald/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mt-3">{title}</h1>
        {subtitle && <p className="text-slate-400 mt-4 max-w-2xl text-sm sm:text-base leading-relaxed">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
